import script from "./RoleRequiredWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredWrapper.vue?vue&type=style&index=0&id=dcc439aa&lang=css"

const __exports__ = script;

export default __exports__